/**
 * HYPEST product options
 * - Add-to-cart stays clickable when no option is chosen
 * - Click then shows "Kies eerst je opties" and jumps to the chips
 * - Sold-out products stay disabled
 */
(function () {
  "use strict";

  function optionRoot(from) {
    if (from && from.closest) {
      var scoped = from.closest(".wt-product, section, product-info");
      if (scoped) {
        var found = scoped.querySelector("variant-options");
        if (found) return found;
      }
    }
    return document.querySelector("variant-options");
  }

  function missingFieldset(root) {
    if (!root) return null;
    var groups = root.querySelectorAll(".wt-product__option");
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      var radios = group.querySelectorAll('input[type="radio"]');
      var select = group.querySelector("select");
      if (radios.length && !group.querySelector('input[type="radio"]:checked')) {
        return group;
      }
      if (select && !String(select.value || "").trim()) {
        return group;
      }
    }
    return null;
  }

  function isProductAvailable(root) {
    if (!root) return true;
    return root.getAttribute("data-available") !== "false";
  }

  function messageFor(root) {
    return (
      (root && root.getAttribute("data-select-first")) ||
      (window.variantStrings && window.variantStrings.selectOptionsFirst) ||
      "Kies eerst je opties"
    );
  }

  function showMissing(fieldset, root) {
    var text = messageFor(root);
    root.querySelectorAll(".hypest-option-error").forEach(function (el) {
      el.hidden = true;
    });
    root.querySelectorAll(".hypest-option--needs-choice").forEach(function (el) {
      el.classList.remove("hypest-option--needs-choice");
    });
    fieldset.classList.add("hypest-option--needs-choice");
    var error = fieldset.querySelector(".hypest-option-error");
    var kindError =
      fieldset.querySelector("[data-option-error]") &&
      fieldset.querySelector("[data-option-error]").getAttribute("data-option-error");
    if (error) {
      error.hidden = false;
      error.textContent = kindError || text;
    }
    var first =
      fieldset.querySelector('input[type="radio"]:not(.disabled)') ||
      fieldset.querySelector('input[type="radio"]') ||
      fieldset.querySelector("select");
    var label =
      first && first.id
        ? fieldset.querySelector('label[for="' + first.id + '"]')
        : first;
    var target = (first && first.closest("li")) || label || fieldset;
    if (target && target.scrollIntoView) {
      target.scrollIntoView({ behavior: "smooth", block: "center" });
    }
    if (label && typeof label.focus === "function") {
      try {
        label.focus({ preventScroll: true });
      } catch (err) {
        label.focus();
      }
    }
  }

  function clearMissing(root) {
    if (!root) return;
    root.querySelectorAll(".hypest-option-error").forEach(function (el) {
      el.hidden = true;
    });
    root.querySelectorAll(".hypest-option--needs-choice").forEach(function (el) {
      el.classList.remove("hypest-option--needs-choice");
    });
    var form = document.querySelector("product-form");
    if (form && typeof form.handleErrorMessage === "function") {
      form.handleErrorMessage();
    }
  }

  function keepClickable(root) {
    root = root || optionRoot();
    if (!root || !isProductAvailable(root) || !missingFieldset(root)) return;
    document
      .querySelectorAll(
        '.product-form__submit, [name="add"], [data-hypest-sticky-atc-button]',
      )
      .forEach(function (btn) {
        if (!btn) return;
        if (!btn.disabled && btn.getAttribute("aria-disabled") !== "true") return;
        btn.removeAttribute("disabled");
        btn.setAttribute("aria-disabled", "false");
        var label =
          btn.querySelector("[data-hypest-sticky-atc-label], span") || btn;
        var soldOut = window.variantStrings && window.variantStrings.soldOut;
        if (
          soldOut &&
          label &&
          (label.textContent || "").trim() === soldOut &&
          window.variantStrings.addToCart
        ) {
          label.textContent = window.variantStrings.addToCart;
        }
      });
  }

  function interceptIfMissing(event, from) {
    var root = optionRoot(from);
    var missing = missingFieldset(root);
    if (!missing) return false;
    event.preventDefault();
    event.stopPropagation();
    showMissing(missing, root);
    return true;
  }

  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      if (!form || form.getAttribute("data-type") !== "add-to-cart-form") return;
      interceptIfMissing(event, form);
    },
    true,
  );

  document.addEventListener(
    "click",
    function (event) {
      var sticky = event.target.closest("[data-hypest-sticky-atc-button]");
      var submit = event.target.closest(
        '.product-form__submit, button[name="add"]',
      );
      if (sticky) {
        interceptIfMissing(event, sticky);
        return;
      }
      if (submit) interceptIfMissing(event, submit);
    },
    true,
  );

  document.addEventListener("change", function (event) {
    var root = event.target.closest && event.target.closest("variant-options");
    if (!root) return;
    if (!missingFieldset(root)) clearMissing(root);
  });

  function wrapVariantOptions() {
    if (!customElements.get("variant-options")) return;
    var proto = customElements.get("variant-options").prototype;
    if (proto.__hypestOptionsWrapped) return;
    proto.__hypestOptionsWrapped = true;

    var originalToggle = proto.toggleAddButton;
    proto.toggleAddButton = function (disable, text, modifyClass) {
      if (isProductAvailable(this) && missingFieldset(this)) {
        return originalToggle.call(
          this,
          false,
          window.variantStrings && window.variantStrings.addToCart,
          modifyClass,
        );
      }
      return originalToggle.call(this, disable, text, modifyClass);
    };

    var originalUnavailable = proto.setUnavailable;
    proto.setUnavailable = function () {
      if (isProductAvailable(this) && missingFieldset(this)) {
        keepClickable(this);
        return;
      }
      return originalUnavailable.call(this);
    };
  }

  var MONTHS_NL = {
    January: "januari",
    February: "februari",
    March: "maart",
    April: "april",
    May: "mei",
    June: "juni",
    July: "juli",
    August: "augustus",
    September: "september",
    October: "oktober",
    November: "november",
    December: "december",
  };

  function dutchShipDate(text) {
    var out = String(text || "");
    out = out.replace(/Expected ship date:/gi, "Verwachte verzenddatum:");
    out = out.replace(/Purchase option\s*\*?/gi, "Besteloptie");
    Object.keys(MONTHS_NL).forEach(function (en) {
      out = out.replace(new RegExp("\\b" + en + "\\b", "g"), MONTHS_NL[en]);
    });
    return out;
  }

  function translateEarlybird() {
    document
      .querySelectorAll(
        ".earlybird__notes_wrapper p, .earlybird__selling_plan_wrapper > label, .earlybird__f_note, .earlybird__pp_note",
      )
      .forEach(function (el) {
        var next = dutchShipDate(el.textContent);
        if (next && next !== el.textContent) el.textContent = next;
      });
  }

  function start() {
    wrapVariantOptions();
    keepClickable();
    translateEarlybird();
    document
      .querySelectorAll(
        '.product-form__submit, [data-hypest-sticky-atc-button]',
      )
      .forEach(function (btn) {
        new MutationObserver(function () {
          keepClickable();
        }).observe(btn, {
          attributes: true,
          attributeFilter: ["disabled", "aria-disabled"],
        });
      });
    var host =
      document.querySelector(".wt-product__add-to-cart_form") ||
      document.querySelector("product-form") ||
      document.body;
    if (host) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          translateEarlybird();
        });
      }).observe(host, { childList: true, subtree: true });
    }
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined("variant-options").then(wrapVariantOptions);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
